export default {
    /** 标题 */
    title: "",
    /** 是否显示取消按钮 */
    showCancelButton: false,
    /** 是否显示确认按钮 */
    showConfirmButton: true,
    /** 确认按钮文字内容 */
    confirmButtonText: "确定",
    /** 确认按钮文字颜色 */
    confirmButtonColor: "#ed4014",
    /** 取消按钮文字内容 */
    cancelButtonText: "取消",
    /** 取消按钮文字颜色 */
    cancelButtonColor: "#c5c8ce",
    /** 点击弹窗背景区域是否关闭弹窗 */
    closeOnClickOverlay: false,
    /** 是否在页面切换时自动关闭 */
    closeOnPopstate: true
}
